import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appInputRestrictionExtended]'
})
export class InputRestrictionExtendedDirective {
  constructor(public control: NgControl) { }

  @HostListener('input', ['$event']) onInput(event) {
    // Allow letters, numbers, spaces, single quotes, double quotes, hyphens
    const inputValue = event.event.target.value;
    const sanitizedValue = inputValue.replace(/[^a-zA-Z0-9\s'"-]/g, '');
    event.event.target.value = sanitizedValue;

    if (this.control.control) {
      this.control.control.setValue(sanitizedValue, { emitEvent: false });
    }
  }

}
